export const environment = {
  production: false,
  APP_MOCK: false,
  USE_HASH: false,
  ADDRESS_APP_SERVICE: "https://www.minegociobcpdesa.viabcp.com",
  CONTEXT_PATH_CAS: "https://authserverdesa.viabcp.com",
  URL_METADATA_MICROFRONTEND: '/assets/metadata/micro-frontends.dev.json',
  API_BCP_URL: "https://apisuxdev.viabcp.com",
  FRONT_DOOR: "https://azfdeu2ppeld01-ahftc7djcve8bbap.a03.azurefd.net",
  STORAGE_ACCOUNT: "https://staceu2ppelfrntd01.z20.web.core.windows.net",
  DATAMART_HOST: "https://homo.connect.datamart.co",
  DATAMART_CONNECTION_ID: "f7b0076a-4303-43b5-b39e-d07d24e6d670",
  CRYPTO_IV: '[;7KM[t+Y46UhN}eB@cqqNN%Dx?;pg48',
  CRYPTO_PASS: 'vbru/A5qaGGL1d,NK_;M0$f30%7CK-pW',
  SCRIPT_ADOBE: "https://assets.adobedtm.com/06a50d0f42e4/394a3e08cc6c/launch-435a98e2975c-development.min.js",
  SCOPE_CAS: "bs-factoring-customer-v1+bs-factoring-evaluation-v3+bs-factoring-notification-management-v1+bs-factoring-order-v1+bs-fraud-evaluation-v1+bs-negotiable-invoice-rate-v1+bs-person-address-v2+bs-person-v5+bs-ppel+bs-product-v4+bs-provider-acquirer-evaluation-v1+bs-risk-evaluation-v1+bs-risk-model-v1+channel-ppel+ux-biom-facial-authorization-v1+cr-token-v1+dt-account-balance-v1+bs-labor-type-v3+bs-branch-office-v3+bs-financial-power-v1+bs-dtex-document-management-v1",
  GTAG_TRACKING_ID: "UA-123669919-1",
  GTAG_SCRIPT: "/resources/scripts/google-gtm-development.js",
  URL_QULQI: "https://public-integration-dev.culqi.xyz/or-onboarding/bcp/mi-negocio",
  grafanaFaro: {
    url: 'https://faro-collector-prod-us-east-0.grafana.net/collect/234730464f35ddbb9d4994e01d8c7e1a',
    app: {
      name: 'ppel-bcp-ppel-angular',
      version: '1.0.0',
      environment: 'dev'
    }
  },
  URL_BFM: 'https://bcp-bfm.dev.coinscrap.com',
  STORAGE_PUBLIC_RESOURCE: 'https://staceu2ppelfrntp01.z20.web.core.windows.net/resources',
  API_URL_B2C: "https://loginsingledesa.viabcp.com/b2ccdev.onmicrosoft.com",
  CLIENT_ID_B2C_PN: 'd1879c3e-a488-4436-a321-6bf8e20598bb',
  CLIENT_ID_B2C_PJ: 'bb7036ba-3b5c-49c8-9eab-30a088e1b939',
  URL_SCOPES_B2C_PN: 'https://b2ccdev.onmicrosoft.com',
  URL_SCOPES_B2C_PJ: 'https://b2ccpymedev.onmicrosoft.com',
  CONTEXT_PATH_B2C_PN: 'https://loginsingledesa.viabcp.com/b2ccdev.onmicrosoft.com/B2C_1A_SIGNIN/oauth2/v2.0/token',
  CONTEXT_PATH_B2C_PJ: 'https://loginsinglepymedesa.viabcp.com/b2ccpymedev.onmicrosoft.com/B2C_1A_SIGNIN_PYME/oauth2/v2.0/token'
}